const inactiveMessages = [
  "ready for it?",
  "get comfortable",
  "fasten your seatbelts",
]

const activeMessages = [
  "heads down",
  "let's go",
  "focus now anak",
  "[lofi music: ON]",
]

const breakMessages = [
  "tea break",
  "[relax: ON]",
  "stretch your legs",
  "snack time",
]

export { inactiveMessages, activeMessages, breakMessages }
